<template>
  <div>
    <b-card>
      <b-row>
        <label class="col-4 my-auto text-left"> Κατώτατο Όριο: </label>
        <b-form-input type="number" v-model="selectedLimit" placeholder="Εισάγετε Όριο(default 3)" @change="limitChanged"
          class="col" :disabled="!chartOptions3.xaxis.categories || !this.series3"></b-form-input>
      </b-row>
      <hr />
      <apex-chart type="bar" height="350" :options="chartOptions3" :series="series3"
        v-if="chartOptions3.xaxis.categories && this.series3"></apex-chart>
      <b-spinner label="Loading..." v-else class="align-middle"></b-spinner>
    </b-card>

  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";
import EsepService from "../../services/esep.service";
import { handleApiError } from "../../services/error.service";

export default {
  components: {
    ApexChart
  },
  mounted() {
    this.$log.debug(this.series)
    this.getEvalCriteriaProgress();
  },
  watch:{
    branch() {
      this.getEvalCriteriaProgress();
    },
    unitId(newUnitId) {
      this.selectedUnitId = newUnitId;
      this.getEvalCriteriaProgress();
    }
  },
  props: {
    branch: String,
    unitId: Number
  },
  data() {
    return {
      selectedLimit: 3,
      selectedUnitId: Number(this.$store.state.globalUnitId) || this.$store.state.userInfo.orgMember.orgUnit.id,
      series3: null,
      chartOptions3: {
        title: {
          text: 'Κριτήρια Αξιολόγησης',
          align: 'left'
        },
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10
          },
        },
        xaxis: {
          categories: null
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      },
    }
  },
  methods: {
    limitChanged(newLimit) {
      this.getEvalCriteriaProgress(newLimit);
    },
    getEvalCriteriaProgress(limit = 3) {
      this.series3 = null;
      this.chartOptions3.xaxis.categories = null;
      EsepService.getEvalCriteriaProgress(this.selectedUnitId, 1, limit).then(
        (response) => {
          this.$log.debug("evalCriteriaProgresss:")
          this.$log.debug(response.data);
          let categories = [];
          let series = [];
          response.data.forEach(AP => {
            categories.push(AP.requirement.title);
            AP.stages.forEach(progressStage => {
              if (series.length < 3) {
                series.push({ name: progressStage.requirement.title, data: [progressStage.completed] });
              } else {
                for (let i = 0; i < series.length; i++) {
                  const stage = series[i];
                  if (progressStage.requirement.title == stage.name) {
                    series[i].data.push(progressStage.completed);
                  }
                }

              }
            })

          });
          this.$log.debug(series);
          this.chartOptions3.xaxis.categories = categories;
          this.series3 = series;

        },
        (error) => {
          this.$log.debug('error')
          this.$log.debug(error.response)
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>

<style>
.comp-spinner {
  align: center;
}
</style>